import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import Logo from './Logo';

const BrandLockup = ({
  size = 36,
  gap = 2.5,
  fontSize = 'xl',
  fontWeight = '900',
  textColor = 'text.main',
  accentColor = 'brand.primary',
  logoColor = '#2563EB',
  letterSpacing = '-0.03em',
  lineHeight = '1',
  className,
}) => {
  return (
    <Flex align="center" gap={gap} className={className} minW={0}>
      <Logo size={size} color={logoColor} />
      <Text
        fontWeight={fontWeight}
        fontSize={fontSize}
        letterSpacing={letterSpacing}
        lineHeight={lineHeight}
        color={textColor}
        whiteSpace="nowrap"
      >
        Dat<Box as="span" color={accentColor}>Lynk</Box>
      </Text>
    </Flex>
  );
};

export default BrandLockup;